import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { AuthService } from '../services/auth.service';

export const apiKeyInterceptorFn: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const isNative = Capacitor.isNativePlatform();
  const skipUrls = ['/auth/login', '/auth/register', '/auth/me'];
  const apiKey = authService.apiKey();

  if (isNative) {
    // Native path: use X-Api-Key only for non-skip endpoints
    if (apiKey && !skipUrls.some(url => req.url.includes(url))) {
      // setHeaders adds the API key without removing any existing headers,
      // so Sentry's sentry-trace and baggage are preserved.
      return next(req.clone({
        setHeaders: { 'X-Api-Key': apiKey },
        withCredentials: true,
      }));
    }
    return next(req);
  }

  // Web / non‑native path: always send HttpOnly session cookies
  return next(req.clone({ withCredentials: true }));
};
